<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="transport-form-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-90 mx-auto text-center" style="margin-bottom:20px">
            <h2
              class="title text-primary black"
              style="margin-top:0px;margin-bottom:30px"
            >{{$t('Transport form')}}</h2>
          </div>
          <div
            v-if="settings.isSignedUp"
            class="md-layout md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto md-gutter"
          >
            <h3
              class="md-layout-item md-size-100 text-center regular"
              style="margin-top:30px"
            >{{$t('Transport request registered')}}</h3>
          </div>
          <div
            v-else-if="!settings.isActive"
            class="md-layout md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto md-gutter"
          >
            <h3
              class="md-layout-item md-size-100 text-center regular"
              style="margin-top:30px"
            >{{$t('Transport form is inactive')}}</h3>
          </div>
          <div
            v-else
            class="md-layout md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto md-gutter"
          >
            <div
              v-if="language.code == 0"
              class="md-layout md-layout-item regular transport-info"
            >
              <p>Szanowni Państwo,</p>
              <p>W celu skorzystania z usług transportowych podczas Forum Ekonomicznego, prosimy o prawidłowe wypełnienie poniższego formularza rezerwacyjnego.</p>
              <p>
                Transfery <b>do Karpacza z Portu Lotniczego we Wrocławiu</b> będą dostępne w dniach 2 i 3 września, natomiast <b>z dworca kolejowego Wrocław Główny</b> 
                w dniu 2 września. Zalecamy wybór transferu odjeżdżającego co najmniej 40 minut po planowanym przylocie/przyjeździe pociągu. Szacowany czas przejazdu do Karpacza 
                wynosi 3,5 godziny.
              </p>
              <p>
                Goście podróżujący z Wrocławia do Karpacza zakwaterowani za pośrednictwem organizatora w hotelach:
                  <span class="single-line">- poza Karpaczem - zostaną przetransportowani do swoich hoteli.</span>
                  <span class="single-line">- w Karpaczu - zostaną przetransportowani do Forum Point.</span>
                
              </p>
              <p>Goście korzystający z transferów nocnych (przylot/przyjazd do Wrocławia po godzinie 21:00) zostaną przetransportowani bezpośrednio do swoich miejsc zakwaterowania.</p>
              <p>
                Transfery <b>z Karpacza do Wrocławia</b> będą realizowane 5 września. Pojazdy <b>najpierw</b> udadzą się <b>do Portu Lotniczego we Wrocławiu</b>, 
                a <b>następnie do Dworca Głównego PKP we Wrocławiu</b>. Szacowany czas przejazdu na lotnisko to 3 godziny, a na dworzec 3 godziny 30 minut.
              </p>
              <p>Pasażerowie lotów powinni stawić się na Lotnisku <b>najpóźniej 2,5 h przed odlotem</b> w celu odprawy.</p>
              <p>Prosimy o uwzględnienie powyższych informacji podczas dokonywania rezerwacji.</p>
            </div>
            <div
              v-else
              class="md-layout md-layout-item regular transport-info"
            >
              <p>Dear Guests of Economic Forum,</p>
              <p>In order to use transportation services during the Economic Forum, please complete the following reservation form correctly.</p>          
              <p>
                Transfers to <b>Karpacz from Wrocław Airport</b> will be available on September 2 and 3, and <b>from the Wrocław Główny railway station</b> on September 2. We recommend 
                choosing a transfer departing at least 40 minutes after the scheduled arrival/train arrival. Estimated travel time to Karpacz is 3.5 hours.
              </p>
              <p>
                Guests traveling from Wroclaw to Karpacz accommodated through the organizer in hotels:
                  <span class="single-line">- outside Karpacz - will be transported to their hotels.</span>
                  <span class="single-line">- In Karpacz - will be transported to Forum Point.</span>
              </p>
              <p>Guests using night transfers (arrival/train arrival in Wroclaw after 21:00) will be transported directly to their accommodations.</p>
              <p>
                Transfers <b>from Karpacz to Wroclaw</b> will be realized after the substantive part of the Program on September 5. The vehicles <b>will first go to 
                the Wroclaw Airport</b> and <b>then</b> to the main railway station in Wroclaw - <b>Wrocław Główny PKP</b>. Estimated travel time to the airport is 3 hours, and 3 hours 30 minutes 
                to the station.
              </p>
              <p>Passengers on flights should appear at the Airport <b>at least 2.5 hours before departure</b> for check-in.</p>
              <p>Please take the above information into account when making your reservation.</p>
            </div>
            <validation-observer
              ref="formValidator"
              v-slot="{ handleSubmit }"
              class="md-layout md-layout-item md-size-100"
            >
              <form
                @submit.prevent="() => {
                  model.departure.datetimeDirty = true;
                  model.arrival.datetimeDirty = true;
                  handleSubmit(onSubmit)}"
                class="md-layout md-layout-item md-size-100"
              >
                <div class="md-layout-item md-size-45 mr-auto">
                  <div
                    class="bold text-primary text-center"
                    style="font-size:24px;margin-bottom:20px"
                  >
                  <md-checkbox v-model="sectionArrivalEnabled"></md-checkbox>
                  {{$t('Transfer from Wrocław to Karpacz')}}</div>

                  <div v-if="sectionArrivalEnabled"> <!-- if enabled start -->

                  <validation-provider rules="required" v-slot="v">
                    <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                      <label
                        for="arrivalPickupDate"
                        class="required"
                      >{{$t('Day of departure from Wrocław')}}</label>
                      <md-select
                        v-model="model.arrival.pickupDate"
                        name="arrivalPickupDate"
                        md-dense
                      >
                        <md-option
                          v-for="day in arrivalDays"
                          :key="day"
                          :value="day"
                        >{{ formatDay(day) }}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      v-show="model.arrival.pickupDate"
                      class="md-form-group"
                      :class="{'md-invalid md-error' : v.failed}"
                    >
                      <label
                        for="arrivalPickupPlace"
                        class="required"
                      >{{$t('Place of departure from Wrocław')}}</label>
                      <md-select v-model="model.arrival.place" name="arrivalPickupPlace" md-dense>
                        <md-option
                          v-for="place in arrivalPlaces"
                          :key="place.location"
                          :value="place.location"
                        >{{place.location}}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular" v-show="model.arrival.pickupDate">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      v-show="selectedArrivalPlace"
                      class="md-form-group"
                      :class="{'md-invalid md-error' : v.failed}"
                    >
                      <label
                        for="arrivalPickupTime"
                        class="required"
                      >{{$t('Time of departure from Wrocław')}}</label>
                      <md-select
                        v-model="model.arrival.pickupTime"
                        name="arrivalPickupTime"
                        md-dense
                      >
                        <md-option
                          v-for="hour in arrivalHours"
                          :key="hour"
                          :value="hour"
                        >{{ formatHour(hour) }}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular" v-show="selectedArrivalPlace">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      class="md-form-group"
                      v-show="selectedArrivalPlace"
                      :class="{'md-invalid md-error' : v.failed}"
                    >
                      <label
                        class="required"
                      >{{ selectedArrivalPlace && selectedArrivalPlace.isAirport ? $t('Number of flight landing in Wroclaw') : $t('Number of train coming to Wroclaw') }}</label>
                      <md-input v-model="model.arrival.nr" />
                    </md-field>
                    <p class="md-error regular" v-show="selectedArrivalPlace">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      class="md-form-group"
                      v-show="selectedArrivalPlace"
                      :class="{'md-invalid md-error' : model.arrival.datetimeDirty && v.failed, 'md-has-value': model.arrival.datetime}"
                    >
                      <datetime
                        v-model="model.arrival.datetime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-zone="europe/warsaw"
                        input-class="md-input"
                        class="theme-primary"
                        @close="model.arrival.datetimeDirty = true; v.validate()"
                      >
                        <label
                          class="required"
                          slot="before"
                        >{{ $t('Date and time of incoming flight/train arrival in Wrocław')}}</label>
                        <template slot="button-cancel">{{$t("Cancel")}}</template>
                        <template slot="button-confirm">{{$t("Confirm")}}</template>
                      </datetime>
                    </md-field>

                    <p class="md-error regular" v-show="selectedArrivalPlace">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <md-field class="md-form-group" v-show="selectedArrivalPlace">
                    <label>{{ $t('The city from which you are arriving/departing to Wroclaw') }}</label>
                    <md-input v-model="model.arrival.fromCity" />
                  </md-field>

                  <md-field class="md-form-group">
                    <label>{{ $t('Name and surname of the accompanying person') }}</label>
                    <md-input v-model="model.arrival.accompanyingPerson" />
                  </md-field>

                  </div> <!-- if enabled end -->
                </div>

                <div class="md-layout-item md-size-45 mr-auto">
                  <div
                    class="bold text-primary text-center"
                    style="font-size:24px;margin-bottom:20px"
                  >
                  <md-checkbox v-model="sectionDepartureEnabled"></md-checkbox>
                  {{$t('Transfer from Karpacz to Wrocław')}}</div>

                  <div v-if="sectionDepartureEnabled"> <!-- if enabled start -->

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                      <label
                        for="departurePickupDate"
                        class="required"
                      >{{$t('The day of departure from Karpacz')}}</label>
                      <md-select
                        v-model="model.departure.pickupDate"
                        name="departurePickupDate"
                        md-dense
                      >
                        <md-option
                          v-for="day in departureDays"
                          :key="day"
                          :value="day"
                        >{{ formatDay(day) }}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      v-show="model.departure.pickupDate"
                      class="md-form-group"
                      :class="{'md-invalid md-error' : v.failed}"
                    >
                      <label
                        for="departurePickupPlace"
                        class="required"
                      >{{$t('Destination point in Wrocław')}}</label>
                      <md-select
                        v-model="model.departure.place"
                        name="departurePickupPlace"
                        md-dense
                      >
                        <md-option
                          v-for="place in departurePlaces"
                          :key="place.location"
                          :value="place.location"
                        >{{place.location}}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular" v-show="model.departure.pickupDate">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      v-show="selectedDeparturePlace"
                      class="md-form-group"
                      :class="{'md-invalid md-error' : v.failed}"
                    >
                      <label
                        for="departurePickupTime"
                        class="required"
                      >{{$t('Time of departure from Karpacz')}}</label>
                      <md-select
                        v-model="model.departure.pickupTime"
                        name="departurePickupTime"
                        md-dense
                      >
                        <md-option
                          v-for="hour in departureHours"
                          :key="hour"
                          :value="hour"
                        >{{ formatHour(hour) }}</md-option>
                      </md-select>
                    </md-field>
                    <p class="md-error regular" v-show="selectedDeparturePlace">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <validation-provider rules="required" v-slot="v" :ref="getRefName()">
                    <md-field
                      class="md-form-group"
                      v-show="selectedDeparturePlace"
                      :class="{'md-invalid md-error' : model.departure.datetimeDirty && v.failed, 'md-has-value': model.departure.datetime}"
                    >
                      <datetime
                        v-model="model.departure.datetime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-zone="europe/warsaw"
                        input-class="md-input"
                        class="theme-primary"
                        @close="model.departure.datetimeDirty = true; v.validate()"
                      >
                        <label
                          class="required"
                          slot="before"
                        >{{ $t('Date and time of departure / train departure from Wrocław')}}</label>

                        <template slot="button-cancel">{{$t("Cancel")}}</template>
                        <template slot="button-confirm">{{$t("Confirm")}}</template>
                      </datetime>
                    </md-field>

                    <p class="md-error regular" v-show="selectedDeparturePlace">
                      <span v-for="error in v.errors" :key="error">{{error}}</span>
                    </p>
                  </validation-provider>

                  <md-field class="md-form-group">
                    <label>{{$t('Name and surname of the accompanying person')}}</label>
                    <md-input v-model="model.departure.accompanyingPerson" />
                  </md-field>

                  </div> <!-- if enabled end -->

                </div>

                <div class="md-layout-item md-size-100 text-right">
                  <md-button
                    class="md-button md-round md-primary md-sm md-theme-default md-blue-border"
                    style="margin-top:20px"
                    type="submit"
                  >{{ $t('Send') }}</md-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import PageHeader from "./layout/PageHeader";
import axios from "@/util/axios";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", required);
import moment from 'moment';
let refCounter = 0;

export default {
  components: { PageHeader, ValidationObserver, ValidationProvider },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    }),
    arrivalDays() {
      return this.settings.arrivalData.map(a => a.day).sort((a, b) => a > b);
    },
    departureDays() {
      return this.settings.departureData.map(a => a.day).sort((a, b) => a > b);
    },
    arrivalPlaces() {
      let dayData = this.settings.arrivalData.filter(
        a => a.day == this.model.arrival.pickupDate
      )[0];

      return dayData
        ? dayData.places.sort((a, b) => a.location > b.location)
        : [];
    },
    departurePlaces() {
      let dayData = this.settings.departureData.filter(
        a => a.day == this.model.departure.pickupDate
      )[0];

      return dayData
        ? dayData.places.sort((a, b) => a.location > b.location)
        : [];
    },
    selectedArrivalPlace() {
      return this.arrivalPlaces.filter(
        a => a.location == this.model.arrival.place
      )[0];
    },
    selectedDeparturePlace() {
      return this.departurePlaces.filter(
        a => a.location == this.model.departure.place
      )[0];
    },
    arrivalHours() {
      var hours = this.selectedArrivalPlace
        ? this.selectedArrivalPlace.hours
        : [];

      return hours.sort((a, b) => a > b);
    },
    departureHours() {
      var hours = this.selectedDeparturePlace
        ? this.selectedDeparturePlace.hours
        : [];

      return hours.sort((a, b) => a > b);
    },
    selectedArrivalHour() {
      return this.arrivalHours.filter(
        a => a == this.model.arrival.pickupTime
      )[0];
    },
    selectedDepartureHour() {
      return this.departureHours.filter(
        a => a == this.model.departure.pickupTime
      )[0];
    }
  },
  data() {
    return {
      image: require("@/assets/img/conference/landing-bg-new.png"), // header img
      model: {
        arrival: {},
        departure: {}
      },

      settings: {},
      loaded: false,

      sectionArrivalEnabled: true,
      sectionDepartureEnabled: true
    };
  },
  methods: {

    formatHour(hour) {
      let newHour = moment.utc(hour).utcOffset(hour).format("HH:mm");
      return newHour;
    },

    formatDay(day) {
      return moment.utc(day).utcOffset(day).format("YYYY-MM-DD");
    },

    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.settings = (
          await axios.get("public/conferences/conference/transport", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    getRefName() {
      refCounter += 1;
      return `ref-${refCounter}`;
    },
    async onSubmit() {
      let loader = this.$loading.show();

      if(!this.sectionDepartureEnabled)
      {
        this.model.departure = null;
      }
      if(!this.sectionArrivalEnabled)
      {
        this.model.arrival = null;
      }

      try {
        let result = await axios.post(
          "public/conferences/conference/transport",
          {
            ...this.model,
            conferenceYear: this.conference.year,
            conferenceType: this.conference.type
          }
        );
        this.$swal({
          icon: "success",
          title: this.$t("Done"),
          text: this.$t("Request has been submitted")
        });

        this.settings.isSignedUp = true;
      } catch (exception) {
        console.log(exception);
      } finally {
        loader.hide();
      }
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    language() {
      var fv = this.$refs.formValidator;
      for (var refName in fv.refs) {
        var v = fv.refs[refName];
        if (v.errors && v.errors.length) {
          v.validate();
        }
      }
    }
  }
};
</script>


<style lang="scss" scoped>
h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

span.single-line{
    display: block;
}

.transport-info {
    display: block;
    margin-bottom: 30px;
    border: 1px solid black;
    padding: 15px
}
</style>


<style lang="scss">
#transport-form-panel {
  .md-field.md-form-group::after,
  .md-field.md-form-group::before,
  .md-field.md-datepicker::after,
  .md-field.md-datepicker::before {
    width: 100%;
  }
  .md-field.md-form-group + .md-error {
    margin-left: 0px;
  }
}
</style>